export const GET_DRIVERS: string = 'src/pages/drivers/GET_DRIVERS';
export const GET_DRIVERS_SUCCESS: string =
  'src/pages/drivers/GET_DRIVERS_SUCCESS';
export const GET_DRIVERS_FAILED: string =
  'src/pages/drivers/GET_DRIVERS_FAILED';

export const GET_DRIVERS_WALLET: string = 'src/pages/drivers/GET_DRIVERS_WALLET';
export const GET_DRIVERS_WALLET_SUCCESS: string =
  'src/pages/drivers/GET_DRIVERS_WALLET_SUCCESS';
export const GET_DRIVERS_WALLET_FAILED: string =
  'src/pages/drivers/GET_DRIVERS_WALLET_FAILED';

export const ADD_DRIVERS_WALLET_TRANSACTION: string = 'src/pages/drivers/ADD_DRIVERS_WALLET_TRANSACTION';
export const ADD_DRIVERS_WALLET_TRANSACTION_SUCCESS: string =
  'src/pages/drivers/ADD_DRIVERS_WALLET_TRANSACTION_SUCCESS';
export const ADD_DRIVERS_WALLET_TRANSACTION_FAILED: string =
  'src/pages/drivers/ADD_DRIVERS_WALLET_TRANSACTION_FAILED';

export const ADD_DRIVERS_WALLET_BULK_TRANSACTION: string = 'src/pages/drivers/ADD_DRIVERS_WALLET_BULK_TRANSACTION';
export const ADD_DRIVERS_WALLET_BULK_TRANSACTION_SUCCESS: string =
  'src/pages/drivers/ADD_DRIVERS_WALLET_BULK_TRANSACTION_SUCCESS';
export const ADD_DRIVERS_WALLET_BULK_TRANSACTION_FAILED: string =
  'src/pages/drivers/ADD_DRIVERS_WALLET_BULK_TRANSACTION_FAILED';

export const GET_DRIVERS_WALLET_TRANSACTION: string = 'src/pages/drivers/GET_DRIVERS_WALLET_TRANSACTION';
export const GET_DRIVERS_WALLET_TRANSACTION_SUCCESS: string =
  'src/pages/drivers/GET_DRIVERS_WALLET_TRANSACTION_SUCCESS';
export const GET_DRIVERS_WALLET_TRANSACTION_FAILED: string =
  'src/pages/drivers/GET_DRIVERS_WALLET_TRANSACTION_FAILED';

export const GET_DRIVER: string = 'src/pages/drivers/GET_DRIVER';
export const GET_DRIVER_SUCCESS: string =
  'src/pages/drivers/GET_DRIVER_SUCCESS';
export const GET_DRIVER_FAILED: string =
  'src/pages/drivers/GET_DRIVER_FAILED';

export const CREATE_DRIVER: string = 'src/pages/drivers/CREATE_DRIVER';
export const CREATE_DRIVER_SUCCESS: string =
  'src/pages/drivers/CREATE_DRIVER_SUCCESS';
export const CREATE_DRIVER_FAILED: string =
  'src/pages/drivers/CREATE_DRIVER_FAILED';

export const CLEAN_DRIVER_LIST: string = 'src/pages/drivers/CLEAN_DRIVER_LIST';

export const UPDATE_DRIVER: string = 'src/pages/drivers/UPDATE_DRIVER';
export const UPDATE_DRIVER_SUCCESS: string =
  'src/pages/drivers/UPDATE_DRIVER_SUCCESS';
export const UPDATE_DRIVER_FAILED: string =
  'src/pages/drivers/UPDATE_DRIVER_FAILED';

export const UPDATE_DRIVER_STATUS: string = 'src/pages/drivers/UPDATE_DRIVER_STATUS';
export const UPDATE_DRIVER_STATUS_SUCCESS: string =
  'src/pages/drivers/UPDATE_DRIVER_STATUS_SUCCESS';
export const UPDATE_DRIVER_STATUS_FAILED: string =
  'src/pages/drivers/UPDATE_DRIVER_STATUS_FAILED';

export const GET_VEHICLE_PREFERRED_SOURCES: string =
  'src/pages/drivers/GET_VEHICLE_PREFERRED_SOURCES';
export const GET_VEHICLE_PREFERRED_SOURCES_SUCCESS: string =
  'src/pages/drivers/GET_VEHICLE_PREFERRED_SOURCES_SUCCESS';
export const GET_VEHICLE_PREFERRED_SOURCES_FAILED: string =
  'src/pages/drivers/GET_VEHICLE_PREFERRED_SOURCES_FAILED';

export const UPDATE_VEHICLE_PREFERRED_SOURCES: string =
  'src/pages/drivers/UPDATE_VEHICLE_PREFERRED_SOURCES';
export const UPDATE_VEHICLE_PREFERRED_SOURCES_SUCCESS: string =
  'src/pages/drivers/UPDATE_VEHICLE_PREFERRED_SOURCES_SUCCESS';
export const UPDATE_VEHICLE_PREFERRED_SOURCES_FAILED: string =
  'src/pages/drivers/UPDATE_VEHICLE_PREFERRED_SOURCES_FAILED';

export const GET_CENTERS: string = 'src/pages/drivers/CENTERS';
export const GET_CENTERS_SUCCESS: string =
  'src/pages/drivers/GET_CENTERS_SUCCESS';
export const GET_CENTERS_FAILED: string =
  'src/pages/drivers/GET_CENTERS_FAILED';

export const GET_DRIVER_SHIFTS: string = 'src/pages/drivers/GET_DRIVER_SHIFTS';
export const GET_DRIVER_SHIFTS_SUCCESS: string =
  'src/pages/drivers/GET_DRIVER_SHIFTS_SUCCESS';
export const GET_DRIVER_SHIFTS_FAILED: string =
  'src/pages/drivers/GET_DRIVER_SHIFTS_FAILED';

export const UPDATE_DRIVER_SHIFTS: string =
  'src/pages/drivers/UPDATE_DRIVER_SHIFTS';
export const UPDATE_DRIVER_SHIFTS_SUCCESS: string =
  'src/pages/drivers/UPDATE_DRIVER_SHIFTS_SUCCESS';
export const UPDATE_DRIVER_SHIFTS_FAILED: string =
  'src/pages/drivers/UPDATE_DRIVER_SHIFTS_FAILED';
